import { Paper } from '@mui/material'
import React from 'react'
import { Route, Routes } from 'react-router-dom'
import Forgot from './forgot/Forgot'
import LoginForm from './LoginForm';

const Auth = () => {
  return (
    <div className='d-flex j-center a-center h-100vh ml-20 mr-20'>
      <Paper className='fit-content pt-40 pb-10 br-9'>
        <Routes>
          <Route path='/forgot' element={<Forgot />} />
          <Route index element={<LoginForm />} />
        </Routes>
      </Paper>
    </div>
  )
}

export default Auth